// SocialAwards.js
import './css/mycss.css';
import { Cards } from './Cards.js';

import img1 from './images/z1.png';
import img2 from './images/z2.png';
import img3 from './images/z3.png';
import img4 from './images/z4.png';
import img5 from './images/s5.png';
import img6 from './images/s6.png';
import img7 from './images/s7.png';

/* ----------------- Export Data for Global Search ----------------- */

export const socialAwardsData = [
  {
    category: "Social",
    htext: "Bharat Ratna",
    ptext: "India’s highest civilian award for exceptional national service.",
    img1,
    ialt: "Bharat Ratna",
    modalContent: `
      <b>Established:</b> 2 January 1954<br/>
            <b>Type:</b> Highest civilian award of India</br>
            <b>First Awarded:</b>1954</br>
            <b>First Recipient:</b>C. Rajagopalachari, Dr. Sarvepalli Radhakrishnan, and Dr. C. V. Raman</br>
            <b>Material:</b>Bronze</br>
            <b>Symbolism:</b>Sun and peepal leaf represent knowledge, enlightenment, and national service at the highest level.</br>
            <b>Awarded For:</b> Exceptional service or performance of the highest order in any field of human endeavor, including public service, art, science, and sports.</br>
            <br/><a href='https://en.wikipedia.org/wiki/Bharat_Ratna'>wiki link</a>
    `
  },
  {
    category: "Social",
    htext: "Padma Vibhushan",
    ptext: "Second-highest civilian honour for exceptional service.",
    img1: img2,
    ialt: "Padma Vibhushan",
    modalContent: `
      <b>Established:</b> 2 January 1954 <br/>
            <b>Type:</b> Second‑highest civilian award</br>
            <b>First Awarded:</b>1954</br>
            <b>First Recipient:</b>Satyendra Nath Bose, Nandalal Bose, Zakir Hussain</br>
            <b>Material:</b> Bronze</br>
            <b>Symbolism:</b>Lotus and emblem denote exceptional and distinguished service to the nation.</br>
            <b>Awarded For:</b>Exceptional and distinguished service” in any field, including government service.</br>
            <br/><a href='https://en.wikipedia.org/wiki/Padma_Vibhushan'>wiki link</a>
    `
  },
  {
    category: "Social",
    htext: "Padma Bhushan",
    ptext: "Civilian award for distinguished service of high order.",
    img1: img3,
    ialt: "Padma Bhushan",
    modalContent: `
      <b>Established:</b> 2 January 1954 <br/>
            <b>Type:</b>Third‑highest civilian award</br>
            <b>First Awarded:</b> 1954</br>
            <b>First Recipient:</b>A. Lakshmanaswami Mudaliar, Shanti Swaroop Bhatnagar and V. Ramaswami</br>
            <b>Material:</b> Bronze</br>
            <b>Symbolism:</b>Lotus symbolizes high‑order contribution and purity of service.</br>
            <b>Awarded For:</b> Distinguished service of a high order in any field, including public affairs.</br>
            <br/><a href='https://en.wikipedia.org/wiki/Padma_Bhushan'>wiki link</a>
    `
  },
  {
    category: "Social",
    htext: "Padma Shri",
    ptext: "Awarded for distinguished service in any field.",
    img1: img4,
    ialt: "Padma Shri",
    modalContent: `
      <b>Established:</b>2 January 1954<br/>
            <b>Type:</b> Fourth‑highest civilian award</br>
            <b>First Awarded:</b>1954</br>
            <b>First Recipient:</b>Bir Bhan Bhatia,Perin Captain,K. R. Chakravorty and Amalprava Das</br>
            <b>Material:</b> Bronze</br>
            <b>Symbolism:</b>Represents recognition of distinguished contribution to society in diverse fields.</br>
            <b>Awarded For:</b>Distinguished service in any field, including social work, medicine, education, literature, sports, and public affairs.</br>
            <br/><a href='https://en.wikipedia.org/wiki/Padma_Shri'>wiki link</a>
    `
  },
  {
    category: "Social",
    htext: "Gandhi Peace Prize",
    ptext: "International recognition for peace and non-violence.",
    img1: img5,
    ialt: "Gandhi Peace Prize",
    modalContent: `
      <b>Established:</b>1995</br>
              <b>Type:</b>International / National Civilian Award (government-sponsored)<br/>
              <b>First Awarded:</b>1995</br>
              <b>First Recipient: </b>Julius Nyerere (former President of Tanzania)</br>
              <b> Symbolism:</b>Based on Gandhian values of peace, non-violence and human dignity.</br>
              <b> Awarded For:</b>Social transformation, peacebuilding, humanitarian work.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Gandhi_Peace_Prize'>wiki link</a></b> 
    `
  },
  {
    category: "Social",
    htext: "Indira Gandhi Prize",
    ptext: "Award for peace, development, and humanitarian progress.",
    img1: img6,
    ialt: "Indira Gandhi Prize",
    modalContent: `
      <b>Established:</b>1986</br>
              <b>Type:</b>International Award (Indira Gandhi Memorial Trust)<br/>
              <b>First Awarded:</b>1986</br>
              <b>First Recipient: </b>Parliamentarians for Global Action</br>
              <b> Symbolism:</b>Reflects Indira Gandhi’s vision of global cooperation and human development.</br>
              <b> Awarded For:</b>Peace, disarmament, development, social justice.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Indira_Gandhi_Prize'>wiki link</a></b> 
    `
  },
  {
    category: "Social",
    htext: "Nari Shakti Puraskar",
    ptext: "India’s highest honour for women empowerment achievements.",
    img1: img7,
    ialt: "Nari Shakti Puraskar",
    modalContent: `
      <b>Established:</b>1999</br>
              <b>Type:</b>National Award<br/>
              <b>First Awarded:</b>1999</br>
              <b>First Recipient: </b>T. Radha K. Prashanti, Bina Sheth Lashkari, Seema Sakhare, Manasi Pradhan, Vartika Nanda, and M. Venkaiah</br>
              <b> Symbolism:</b>Represents women’s strength, leadership and empowerment.</br>
              <b> Awarded For:</b>Outstanding contribution to women’s empowerment and social change.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Nari_Shakti_Puraskar'>wiki link</a></b> 
    `
  }
];

/* ----------------- Page Component ----------------- */

export default function SocialAwards() {
  return (
    <div>
      <h1 className="heading">Social Awards</h1>
      <h3 className="head2">“Honouring those who uplift communities and strengthen society.”</h3>

      <div className="search-cards-container">
        {socialAwardsData.map((award, i) => (
          <Cards
            key={i}
            htext={award.htext}
            ptext={award.ptext}
            img1={award.img1}
            ialt={award.ialt}
            btext="learn more"
            modalContent={award.modalContent}
          />
        ))}
      </div>
    </div>
  );
}
